import React from 'react'
import LogoImage from "../assets/Group 1.png";
const Logo = () => {
  return (
    <img src={LogoImage} alt='logo' width={67}/>
  )
}

export default Logo